import { createGlobalStyle } from 'styled-components';

const MobileHeaderRemover = createGlobalStyle`
  [data-mobile="true"] {
    .desktop-header { display: none; }
  }
`;

export default MobileHeaderRemover;
